// extracted by mini-css-extract-plugin
export default {"cta":"JF-z","disabled":"KF-z"};